export const createConnection = () => ({
  host: '',
  port: 2022,
  username: '',
  password: '',
  protocol: 'sftp'
});

export const normalizeProtocol = (protocol) => protocol === 'ftps' ? 'ftps' : 'sftp';

const stripProtocolPrefix = (value) =>
String(value || '').replace(/^(s?ftps?:\/\/)/i, '');

export const parseHostInput = (value, fallbackProtocol = 'sftp') => {
  const raw = String(value || '').trim();
  let protocol = normalizeProtocol(fallbackProtocol);
  let host = raw;
  let port = null;

  if (raw.includes('://')) {
    try {
      const url = new URL(raw);
      host = url.hostname || '';
      if (url.protocol) {
        protocol = normalizeProtocol(url.protocol.replace(':', ''));
      }
      if (url.port) {
        port = Number(url.port);
      }
      if (!host) {
        host = stripProtocolPrefix(raw);
      }
    } catch {
      host = stripProtocolPrefix(raw);
    }
  } else {
    host = stripProtocolPrefix(raw);
  }

  if (host.includes('@')) {
    host = host.split('@').pop() || '';
  }

  if (host.includes('/')) {
    host = host.split('/')[0];
  }

  if (port === null) {
    const match = host.match(/:(\d+)$/);
    if (match) {
      port = Number(match[1]);
      host = host.slice(0, -match[0].length);
    }
  }

  return { host, port, protocol };
};

export const normalizeConnection = (config) => {
  const { host, port: parsedPort, protocol } = parseHostInput(
    config?.host,
    config?.protocol
  );

  return {
    host,
    port: Number(config?.port) || parsedPort || (protocol === 'ftps' ? 21 : 2022),
    username: config?.username || '',
    password: config?.password || '',
    protocol
  };
};

export const matchesDeepLinkConnection = (payload, currentConfig) => {
  if (!payload || !currentConfig) return false;
  const current = normalizeConnection(currentConfig);
  const host = (payload.host || '').trim();
  if (host && host !== current.host) return false;
  const protocol = payload.protocol ? normalizeProtocol(payload.protocol) : '';
  if (protocol && protocol !== current.protocol) return false;
  const hasPort =
  payload.port !== undefined && payload.port !== null && String(payload.port).length > 0;
  if (hasPort && Number(payload.port) !== current.port) return false;
  const username = payload.username || payload.user || '';
  if (username && username !== current.username) return false;
  return true;
};
